import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b29e378"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-main" }
const _hoisted_2 = {
  key: 0,
  style: {"height":"600px"}
}
const _hoisted_3 = {
  key: 0,
  class: "loadingIndicator"
}

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_CalendarView = _resolveComponent("CalendarView")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.eventData !== [])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_CalendarView, {
            eventData: _ctx.eventData,
            "onUpdate:eventData": _cache[0] || (_cache[0] = $event => ((_ctx.eventData) = $event)),
            viewSelector: true,
            todayButton: true,
            onEventItemClicked: _ctx.eventItemClicked,
            onUiDateTimeRangeChanged: _ctx.uiDateTimeRangeChanged,
            defaultView: "M",
            header: "Calendar"
          }, {
            buttons: _withCtx(() => [
              (_ctx.loadingEvents)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createVNode(_component_LoadingIndicator, { showLoadingText: false })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["eventData", "onEventItemClicked", "onUiDateTimeRangeChanged"])
        ]))
      : _createCommentVNode("", true)
  ]))
}